import * as React from 'react';
import { styled } from '../../styles';
import { icons, IconType } from './icons';

const StyledIcon = styled('svg', {
  display: 'inline-block',
  verticalAlign: 'middle',
});

type BaseSVGProps = Omit<React.ComponentPropsWithoutRef<'svg'>, 'color' | 'children'>;

export interface IconProps extends BaseSVGProps {
  icon: IconType;
  size?: number | string;
  color?: string;
  title?: string;
  spin?: boolean;
}

export function Icon({
  icon,
  size = 24,
  color = '#ffffff',
  title,
  spin = false,
  style,
  ...rest
}: Readonly<IconProps>) {
  const iconDef = icons[icon];
  if (!iconDef) return null;

  const finalSize = typeof size === 'number' ? `${size}px` : size;

  return (
    <StyledIcon
      role="img"
      aria-label={title || icon}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={iconDef.viewBox}
      style={{
        width: finalSize,
        height: finalSize,
        color,
        ...(spin ? { animation: 'icon-spin 1s linear infinite' } : null),
        ...(rest.onClick ? { cursor: 'pointer' } : null),
        ...style,
      }}
      {...rest}
    >
      {title && <title>{title}</title>}
      {iconDef.path}
    </StyledIcon>
  );
}